import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" id="footer">
      <div className="footer-background">
        <div className="footer-gradient"></div>
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>

      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand">
              <h3 className="footer-name">
                <span className="name-highlight">Gaurav Singh</span>
              </h3>
              <p className="footer-tagline">
                Full Stack Developer & Problem Solver
              </p>
              <p className="footer-description">
                Building exceptional digital experiences with passion and precision.
                Let's create something amazing together.
              </p>
            </div>

            <div className="footer-links">
              <div className="footer-section">
                <h4 className="footer-heading">Quick Links</h4>
                <ul className="footer-list">
                  <li>
                    <button
                      className="footer-link"
                      onClick={() => scrollToSection('hero')}
                    >
                      Home
                    </button>
                  </li>
                  <li>
                    <button
                      className="footer-link"
                      onClick={() => scrollToSection('about')}
                    >
                      About
                    </button>
                  </li>
                  <li>
                    <button
                      className="footer-link"
                      onClick={() => scrollToSection('projects')}
                    >
                      Projects
                    </button>
                  </li>
                  <li>
                    <button
                      className="footer-link"
                      onClick={() => scrollToSection('contact')}
                    >
                      Contact
                    </button>
                  </li>
                </ul>
              </div>

              <div className="footer-section">
                <h4 className="footer-heading">Technologies</h4>
                <ul className="footer-list">
                  <li><span className="footer-text">React & Next.js</span></li>
                  <li><span className="footer-text">Node.js & Express</span></li>
                  <li><span className="footer-text">MongoDB & PostgreSQL</span></li>
                  <li><span className="footer-text">JavaScript & TypeScript</span></li>
                </ul>
              </div>

              <div className="footer-section">
                <h4 className="footer-heading">Connect</h4>
                <div className="footer-social">
                  <a href="https://github.com/Gaurav-singh101" className="social-link" aria-label="GitHub" target="_blank" rel="noopener noreferrer">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                    </svg>
                    <span className="social-text">GitHub</span>
                  </a>
                  <a href="https://www.linkedin.com/in/gaurav-singh-0191a028a/" className="social-link" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                    <span className="social-text">LinkedIn</span>
                  </a>
                  <a href="https://x.com/Gauravs27356652" className="social-link" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                    </svg>
                    <span className="social-text">Twitter</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-divider"></div>
            <div className="footer-bottom-content">
              <div className="footer-copyright">
                <p>&copy; {currentYear} Gaurav Singh. All rights reserved.</p>
                <p className="footer-made-with">
                  Made with <span className="heart"></span> and <span className="code">{'</>'}</span>
                </p>
              </div>

              <button
                className="scroll-to-top"
                onClick={scrollToTop}
                aria-label="Scroll to top"
              >
                <span className="scroll-text">Back to Top</span>
                <div className="arrow-up">↑</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;